import { render } from "./KnowledgeSmall.vue?vue&type=template&id=897d5f14&scoped=true"
import script from "./KnowledgeSmall.vue?vue&type=script&lang=js"
export * from "./KnowledgeSmall.vue?vue&type=script&lang=js"

import "./KnowledgeSmall.vue?vue&type=style&index=0&id=897d5f14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897d5f14"]])

export default __exports__